// Generated by avro-typescript-cli
// Schemas:
//   HeroPostOpenPostExperience:1
//   HeroPostOpenFlyer:1
//   HeroPostFlyerViewFlyer:1
//   HeroPostFlyerEngagedVisitFlyer:1
//   HeroPostFlyerClickFlyerItem:1
//   HeroPostClosePost:1
export namespace com.flipp.beacon.common.enumeration {
	export enum ApplicationID { FlippApp = "FlippApp", FlippWeb = "FlippWeb", Flyers = "Flyers", Hosted = "Hosted", GMA = "GMA", Editorials = "Editorials", Hero = "Hero", Other = "Other", FlippAvroDefault = "FlippAvroDefault" }
}

export namespace com.flipp.beacon.common.entity {
	export interface Base {
		aid: com.flipp.beacon.common.enumeration.ApplicationID;
		rnd: string;
		postalCode: null | { "string": string };
	}
}

export namespace com.flipp.beacon.common.entity {
	export interface Budget {
		budgetId: number;
		costModelType: null | { "string": string };
	}
}

export namespace com.flipp.beacon.common.entity {
	export interface Publisher {
		publisherId: number;
		channelId: null | { "number": number };
	}
}

export namespace com.flipp.beacon.hero.enumeration {
	export enum Environment { Prod = "Prod", Dev = "Dev", Test = "Test" }
}

export namespace undefined {
	export interface ClientParameters {
		browser: string;
		browserVersion: string;
		system: string;
		systemModel: string;
		systemVersion: string;
	}
}

export namespace com.flipp.beacon.hero.enumeration {
	export enum LocationSource { Unknown = "Unknown", GeoIP = "GeoIP", Default = "Default" }
}

export namespace undefined {
	export interface HeroCampaign {
		moduleId: number;
		campaignId: number;
	}
}

export namespace com.flipp.beacon.hero.entity {
	export interface HeroBase {
		environment: com.flipp.beacon.hero.enumeration.Environment;
		clientParameters: undefined.ClientParameters;
		LocationSource: com.flipp.beacon.hero.enumeration.LocationSource;
		epochMilliseconds: number;
		sessionId: string;
		sequenceId: number;
		appVersion: string;
		heroCampaign: undefined.HeroCampaign;
	}
}

export namespace com.flipp.beacon.common.entity {
	export interface SchemaInfo {
		schemaId: number;
	}
}

export namespace com.flipp.beacon.hero.event.postExperience {
	export interface HeroPostOpenPostExperience {
		base: com.flipp.beacon.common.entity.Base;
		budget: com.flipp.beacon.common.entity.Budget;
		publisher: com.flipp.beacon.common.entity.Publisher;
		heroBase: com.flipp.beacon.hero.entity.HeroBase;
		schemaInfo: com.flipp.beacon.common.entity.SchemaInfo;
	}
}

export namespace com.flipp.beacon.common.entity {
	export interface Flyer {
		flyerId: number;
		flyerRunId: number;
		flyerTypeId: number;
		premium: boolean;
	}
}

export namespace com.flipp.beacon.common.entity {
	export interface Merchant {
		merchantId: number;
	}
}

export namespace com.flipp.beacon.hero.enumeration {
	export enum SourceAction { Direct = "Direct", CrossBrowse = "CrossBrowse" }
}

export namespace com.flipp.beacon.hero.event.postExperience {
	export interface HeroPostOpenFlyer {
		base: com.flipp.beacon.common.entity.Base;
		budget: com.flipp.beacon.common.entity.Budget;
		publisher: com.flipp.beacon.common.entity.Publisher;
		flyer: com.flipp.beacon.common.entity.Flyer;
		merchant: com.flipp.beacon.common.entity.Merchant;
		sourceAction: com.flipp.beacon.hero.enumeration.SourceAction;
		heroBase: com.flipp.beacon.hero.entity.HeroBase;
		schemaInfo: com.flipp.beacon.common.entity.SchemaInfo;
	}
}

export namespace com.flipp.beacon.hero.entity {
	export interface ViewParameters {
		left: number;
		right: number;
		top: number;
		bottom: number;
		resolution: number;
		userScreenHeight: number;
		userScreenWidth: number;
		devicePixelRatio: number;
	}
}

export namespace com.flipp.beacon.hero.event.postExperience {
	export interface HeroPostFlyerViewFlyer {
		base: com.flipp.beacon.common.entity.Base;
		budget: com.flipp.beacon.common.entity.Budget;
		publisher: com.flipp.beacon.common.entity.Publisher;
		flyer: com.flipp.beacon.common.entity.Flyer;
		merchant: com.flipp.beacon.common.entity.Merchant;
		heroBase: com.flipp.beacon.hero.entity.HeroBase;
		viewParameters: com.flipp.beacon.hero.entity.ViewParameters;
		schemaInfo: com.flipp.beacon.common.entity.SchemaInfo;
	}
}

export namespace com.flipp.beacon.hero.event.postExperience {
	export interface HeroPostFlyerEngagedVisitFlyer {
		base: com.flipp.beacon.common.entity.Base;
		budget: com.flipp.beacon.common.entity.Budget;
		publisher: com.flipp.beacon.common.entity.Publisher;
		flyer: com.flipp.beacon.common.entity.Flyer;
		merchant: com.flipp.beacon.common.entity.Merchant;
		heroBase: com.flipp.beacon.hero.entity.HeroBase;
		repeat: boolean;
		schemaInfo: com.flipp.beacon.common.entity.SchemaInfo;
	}
}

export namespace com.flipp.beacon.common.entity {
	export interface FlyerItem {
		id: number;
	}
}

export namespace com.flipp.beacon.hero.event.postExperience {
	export interface HeroPostFlyerClickFlyerItem {
		base: com.flipp.beacon.common.entity.Base;
		budget: com.flipp.beacon.common.entity.Budget;
		publisher: com.flipp.beacon.common.entity.Publisher;
		flyer: com.flipp.beacon.common.entity.Flyer;
		flyerItem: com.flipp.beacon.common.entity.FlyerItem;
		merchant: com.flipp.beacon.common.entity.Merchant;
		heroBase: com.flipp.beacon.hero.entity.HeroBase;
		schemaInfo: com.flipp.beacon.common.entity.SchemaInfo;
	}
}

export namespace com.flipp.beacon.hero.event.postExperience {
	export interface HeroPostClosePost {
		base: com.flipp.beacon.common.entity.Base;
		budget: com.flipp.beacon.common.entity.Budget;
		publisher: com.flipp.beacon.common.entity.Publisher;
		flyer: com.flipp.beacon.common.entity.Flyer;
		merchant: com.flipp.beacon.common.entity.Merchant;
		heroBase: com.flipp.beacon.hero.entity.HeroBase;
		schemaInfo: com.flipp.beacon.common.entity.SchemaInfo;
	}
}

// auto-generated file - not so auto-generated
// this ids from prod api (it was hardcoded here)
// but if u will run 'npm run avro-beacons' it will override it from stg api
// stg and prod schema ids are different
export const HeroPostOpenPostExperienceSchemaId = 1964;
export const HeroPostOpenFlyerSchemaId = 1963;
export const HeroPostFlyerViewFlyerSchemaId = 1962;
export const HeroPostFlyerEngagedVisitFlyerSchemaId = 1961;
export const HeroPostFlyerClickFlyerItemSchemaId = 1960;
export const HeroPostClosePostSchemaId = 1959;
